"use client"

import {App} from "antd";

export const useNotification = () => {
    const {notification} = App.useApp();

    const configDefault = {
        closeIcon: <CloseIcon />,
    }

    const errorNotification = {
        ...configDefault,
        className: 'error_notification',
        icon: <ErrorIcon />,
    }

    const successNotification = {
        ...configDefault,
        className: 'success_notification',
        icon: <SuccessIcon />,
    }

    const warningNotification = {
        ...configDefault,
        className: 'warning_notification',
        icon: <WarningIcon />,
    }

    const infoNotification = {
        ...configDefault,
        className: 'info_notification',
        icon: <WarningIcon />,
    }

    const configNotification = (type) =>{
        switch (type){
            case 'error':
                return errorNotification
            case 'success':
                return successNotification
            case 'warning':
                return warningNotification
            case 'info':
                return infoNotification
            default:
                return configDefault
        }
    }

    return ({type, ...rest}) => {
        notification.open({
            ...configNotification(type),
            ...rest
        })
    };
}

const ErrorIcon = ({...props}) =>{
    return(
        <svg
            width={20}
            height={20}
            fill="#C12514"
            {...props}
        >
            <path
                d="M15.576 18.958H4.423c-1.199 0-2.282-.613-2.899-1.64a3.342 3.342 0 0 1-.082-3.32L6.947 3.703a3.408 3.408 0 0 1 3.051-1.827c1.299 0 2.44.682 3.051 1.827l5.505 10.295a3.336 3.336 0 0 1-.08 3.32 3.343 3.343 0 0 1-2.898 1.64ZM10 3.125c-.83 0-1.558.436-1.95 1.166L2.547 14.587a2.103 2.103 0 0 0 .051 2.087 2.112 2.112 0 0 0 1.827 1.034h11.154c.755 0 1.439-.387 1.826-1.034a2.104 2.104 0 0 0 .051-2.087L11.95 4.29A2.18 2.18 0 0 0 10 3.125Zm.625 8.542V8.333a.625.625 0 0 0-1.25 0v3.334a.625.625 0 0 0 1.25 0Zm.225 2.5a.833.833 0 0 0-.833-.834h-.009a.83.83 0 0 0-.829.834c0 .46.378.833.838.833.46 0 .833-.373.833-.833Z"
            />
        </svg>
    )
}

const SuccessIcon = ({...props}) =>{
    return(
        <svg
            width={20}
            height={20}
            fill="#068F4E"
            {...props}
        >
            <path
                d="m17.942 6.275-8.334 8.333a.625.625 0 0 1-.441.184h-.003a.626.626 0 0 1-.443-.187L5.387 11.22a.625.625 0 0 1 .891-.878L9.17 13.28l7.889-7.888a.625.625 0 0 1 .884.884Zm-8.775 5.183c.16 0 .32-.06.441-.183l5-5a.625.625 0 1 0-.884-.884l-5 5a.625.625 0 0 0 .443 1.067Zm-6.222-1.113a.625.625 0 1 0-.89.877l3.332 3.384a.621.621 0 0 0 .884.007.625.625 0 0 0 .006-.885l-3.332-3.383Z"
            />
        </svg>
    )
}

const WarningIcon = ({...props}) =>{
    return(
        <svg
            width={20}
            height={20}
            fill="#DD7A02"
            {...props}
        >
            <path
                d="M10 18.958c-4.94 0-8.958-4.018-8.958-8.958S5.06 1.042 10 1.042 18.958 5.06 18.958 10 14.94 18.958 10 18.958Zm0-16.666c-4.25 0-7.708 3.457-7.708 7.708 0 4.25 3.457 7.708 7.708 7.708 4.25 0 7.708-3.457 7.708-7.708 0-4.25-3.457-7.708-7.708-7.708Zm.85 10.625a.833.833 0 0 0-.833-.834h-.009a.83.83 0 0 0-.829.834c0 .46.378.833.838.833.46 0 .833-.373.833-.833Zm-.225-2.858V6.25a.625.625 0 0 0-1.25 0v3.81a.625.625 0 0 0 1.25 0Z"
            />
        </svg>
    )
}

const CloseIcon = ({...props}) =>{
    return(
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            fill="#C12514"
            {...props}
        >
            <path
                d="M10 1.042C5.06 1.042 1.042 5.06 1.042 10c0 4.94 4.018 8.958 8.958 8.958S18.958 14.94 18.958 10c0-4.94-4.018-8.958-8.958-8.958Zm0 16.666c-4.25 0-7.708-3.457-7.708-7.708 0-4.25 3.457-7.708 7.708-7.708 4.25 0 7.708 3.457 7.708 7.708 0 4.25-3.457 7.708-7.708 7.708Zm2.942-9.766L10.883 10l2.059 2.058a.625.625 0 0 1-.884.885L10 10.884l-2.058 2.059a.623.623 0 0 1-.884 0 .625.625 0 0 1 0-.885L9.117 10 7.058 7.942a.625.625 0 0 1 .885-.885L10 9.117l2.058-2.058a.625.625 0 1 1 .883.884Z"
            />
        </svg>
    )
}